import { call, put, select } from 'redux-saga/effects';
import { FeedMediaStates, RTCClient } from 'utils/webrtc';
import { interactionTriggered } from 'features/application/actions';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { logger } from 'utils/logger';
import { selectMediaDevicePermissions } from 'features/user-media/userMediaSlice';
import { type PermissionStatus } from 'features/user-media/types';

export function* toggleLocalAudioSaga() {
  const canBroadcastAudio: boolean = yield call(hasPermissionsSaga, PermissionTypes.broadcastAudio);
  if (!canBroadcastAudio) {
    logger.remote().warn('Tried to toggle audio without broadcast permission');
    return;
  }

  const micPermissions: PermissionStatus = yield select(selectMediaDevicePermissions, 'audioinput');
  if (micPermissions !== 'granted') {
    logger.remote().warn('Tried to toggle audio without media device permission');
    return;
  }

  const mediaStates: FeedMediaStates = yield call(RTCClient.publishingFeed.getMediaStates);

  if (mediaStates.audio.broadcasting) {
    yield put(interactionTriggered('muteAudio'));
  } else {
    yield put(interactionTriggered('unmuteAudio'));
  }

  yield call(RTCClient.publishingFeed.toggleAudioBroadcasting);
}
